import React, { FC, useCallback, useContext, useState } from 'react';

import { Button, Input, Paragraph } from '@smartshell/ui-kit';
import cn from 'classnames';
import { HexColorPicker } from 'react-colorful';

import { LocalizationContext } from 'localization';

import s from './ColorPicker.module.scss';
import { IColorPicker } from './interfaces';

const CustomColor: FC<IColorPicker> = ({ color, setColor, variant, close }) => {
  const { t } = useContext(LocalizationContext);
  const [currentColor, setCurrentColor] = useState(color);

  const [inputValue, setInputValue] = useState<string>(color);
  const [isValid, setIsValid] = useState<boolean>(true);

  const setColorHandler = useCallback(() => {
    setColor(currentColor);
    close();
  }, [currentColor, setColor]);

  const handleColorChange = (value: string): void => {
    setInputValue(value);
    setIsValid(/^#[0-9A-F]{6}$/i.test(value));
  };

  const handleCurrentColor = (value: string): void => {
    setInputValue(value);
    setCurrentColor(value);
  };

  return (
    <>
      <div
        className={cn(
          s.modal__color,
          variant === 'secondary' && s.modal__color_secondary
        )}
      >
        <HexColorPicker
          color={currentColor}
          onChange={handleCurrentColor}
          className={
            variant === 'primary' ? s.colorPicker : s.colorPicker_secondary
          }
        />

        <Input
          value={inputValue}
          onChange={handleColorChange}
          title={t('hex_code.title')}
          bordered
          error={!isValid ? t('hex_code.error') : undefined}
          onBlur={() => {
            if (isValid) {
              setCurrentColor(inputValue);
            } else {
              setInputValue(currentColor);
              setIsValid(true);
            }
          }}
          variant={variant}
          rightContent={
            variant === 'secondary' ? (
              <Paragraph color="secondary">HEX</Paragraph>
            ) : undefined
          }
          className={
            variant === 'secondary' ? s.modal_secondary__input : undefined
          }
        />
      </div>
      <div className={s.modal__buttons}>
        <Button
          fullWidth
          size={variant === 'primary' ? 'l' : 's'}
          onClick={setColorHandler}
        >
          {t('apply')}
        </Button>
        {variant === 'primary' && (
          <Button fullWidth variant="secondary" size="l" onClick={close}>
            {t('cancel')}
          </Button>
        )}
      </div>
    </>
  );
};

export default CustomColor;
